import React from 'react';

import { skillsData } from '../data/data';

const Skills = () => {
  return (
    <div name="skills" className="w-full min-h-screen pt-[100px] bg-[#0a192f] text-gray-300">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-pink-600 ">Skills</p>
          <p className="py-4">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          {skillsData.map(skill => (
            <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center h-32">
              <img className="w-20" src={skill.image} alt={`${skill.name} icon`} />
              <p className="mt-2">{skill.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
